import { useSelector } from 'react-redux';

const useGrouping = () => {
    const grouping = useSelector(state => state.contract_globals.grouping);
    if (grouping) {
        return grouping;
    }

    return null;
}

export default useGrouping;
